import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { createPinia } from 'pinia'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'animate.css';
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useVSCStore } from '@/store'

const pinia = createPinia()

axios.defaults.baseURL = process.env.VUE_APP_URL_OFICINA
const axiosAuth = axios.create()
axiosAuth.defaults.baseURL = process.env.VUE_APP_URL_OFICINA

export { axiosAuth }

const app = createApp(App).provide('axiosAuth',axiosAuth).use(pinia)

const store = useVSCStore()

AOS.init()

axiosAuth.interceptors.response.use(response => response,async error => {
    if (error.response.status === 401) {
        await store.logoutActions()
    }
    return Promise.reject(error)
})
store.tryAutoLogin().then(() => {
    app.use(router).use(VueAxios,axios).use(VueSweetalert2).mount('#app')
})
